<template>
  <v-app>
     <router-view />
  <VersionUpdateNotifier/>
  <HrvecChatbot/>
  </v-app>
</template>
<script>
import VersionUpdateNotifier from './views/dashboard/components/VersionUpdateNotifier.vue';
import HrvecChatbot from './chatbot/HrvecChatbot.vue';

export default {
  name: "App",
  components:{
    VersionUpdateNotifier,
    HrvecChatbot
  },
  data() {
    return {};
  },
  created() {
    // โหลด version ตอนสร้าง component
    this.loadVersion();
  },

  async mounted() {
    if (this.$store) {
      this.$store.dispatch("version/fetchVersion");
    }
  },

   methods: {
    async loadVersion() {
      try {
        if (this.$store && this.$store.dispatch) {
          await this.$store.dispatch('version/fetchVersion');
          console.log('✅ Version loaded successfully');
        }
      } catch (error) {
        console.warn('⚠️ Could not load version:', error);
      }
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@300&display=swap");
</style>

<style>
.flex-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.text_google {
  font-family: "Kanit", sans-serif;
}
.back-drow {
  background: rgb(1, 25, 53);
  background: linear-gradient(
    0deg,
    rgb(35, 38, 42) 0%,
    rgb(80, 92, 108) 35%,
    rgb(175, 183, 193) 100%
  );
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(107, 105, 105);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #7c9cdb;
}
</style>
